import { Dialog, Transition } from "@headlessui/react"
import React, { Fragment } from "react"
import Camera, {FACING_MODES, IMAGE_TYPES} from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";

interface IProps {
    isOpen: boolean,
    onTakePhoto: (dataUri: string) => void
}

export default function CameraPicker(props: IProps) {
    function closeModal() {
        //
    }

    function handleTakePhoto (dataUri: string) {
        // remove the base64 header from dataUri
        props.onTakePhoto(dataUri.split(",").pop()!)
    }

    return (
        <>
            <Transition appear show={props.isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={closeModal}>
                    <div className="fixed inset-0">
                        <div className="flex min-h-full h-screen w-screen items-center justify-center text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full h-full flex items-center justify-center bg-black transform transition-all">
                                    <Camera
                                        idealFacingMode = {FACING_MODES.ENVIRONMENT}
                                        imageType = {IMAGE_TYPES.JPG}
                                        imageCompression = {0.97}
                                        isMaxResolution = {true}
                                        isImageMirror = {false}
                                        isSilentMode = {false}
                                        isDisplayStartCameraError = {true}
                                        isFullscreen = {false}
                                        sizeFactor = {1}
                                        onTakePhoto = { (dataUri: string) => {
                                            handleTakePhoto(dataUri);
                                        } }
                                    />
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
